export type SignalSubscriber<T> = (value: T) => void

export interface Signal<T> {
  get(): T
  set(v: T): void
  subscribe(cb: SignalSubscriber<T>): () => void
}

export function createSignal<T>(initial: T): Signal<T> {
  let value = initial
  const subs = new Set<SignalSubscriber<T>>()

  return {
    get() {
      return value
    },

    set(v: T) {
      if (Object.is(value, v)) return
      value = v
      subs.forEach((s) => s(v))
    },

    subscribe(cb) {
      subs.add(cb)
      return () => subs.delete(cb)
    },
  }
}
